/* -- Generated File: Do Not Edit ------------------------------------------ */
export const borderRadiusValues = {
  borderRadius0: 4,
  borderRadius1: 6,
  borderRadius2: 100,
};

export default borderRadiusValues;
/* -- Generated File: Do Not Edit ------------------------------------------ */
